export const widgetIds = {
    "main": {
        "push":
            {
                "prevPc": "30232",
                "prevMob": "30234",
                "fullPc": "30233",
                "fullMob": "30235"
            },
        "toPad":
            {
                "prevPc": "30171",
                "prevMob": "30186",
                "fullPc": "30210",
                "fullMob": "30242"
            },
        "fullScreen":
            {
                "fullMob": "32664"
            },
        "floorAd":
            {
                "fullMob": "32665",
            },
        "popupModal":
            {
                "prevPc": "30206",
                "fullPc": "30236",
            },
        "ir1":
            {
                "fullPc": "30219",
                "fullMob": "30225"
            },
        "ir2":
            {
                "fullPc": "30218",
                "fullMob": "30226"
            },
        "ir3":
            {
                "fullPc": "30220",
                "fullMob": "30227"
            },
        "ir4":
            {
                "fullPc": "30221",
                "fullMob": "30228"
            },
        "aa":
            {
                "fullPc": "30222",
                "fullMob": "30224"
            },
        "feed":
            {
                "prevPc": ["30173", "30174", "30175"],
                "prevMob": ["30187", "30188"],
                "fullPc": "30223",
                "fullMob": ["30229", "30230"]
            },
        "sideBar":
            {
                "prevPc": "30172",
                "fullPc": ["30211", "30212", "30213", "30214"]
            },
        "backClick": "30205",
        "popup": "30231",
    },
}
